<div class="lock"></div>
<div class="message">
  <h1>{{ 'FORBIDDEN_PAGE.HEADER' | translate }}</h1>
  <p>{{ 'FORBIDDEN_PAGE.DESCRIPTION' | translate }}</p>
</div>
